import axiosIns from '@/plugins/axios'

// 店舗単位のβ機能フラグ。
// キーの定義（存在するフラグ・デフォルト値・ラベル）はバックエンドの
// ClubFeatureFlags::DEFINITIONS が真の所在で、サーバーが camelCase のキーで返す/受ける。
// そのため camelcase-keys / snakecase-keys は通さない
// （useTableOverview3Column のように数字が混じるキーは自動変換の往復が保証されないため）。
export default {
  getFeatureFlags() {
    return axiosIns.get('/waiter/feature_flags')
  },

  // 部分更新。渡したフラグだけが変わり、渡さなかったフラグは現在値が保たれる。
  updateFeatureFlags(flags) {
    return axiosIns.put('/waiter/feature_flags', { feature_flags: flags })
  },
}
